import React from "react";
import ReactDOM from "react-dom";
import App from "./AppPage";
import * as serviceWorker from "./serviceWorker";
import "./assets/css/style.min.css";
import { Provider } from "react-redux";
import "./assets/css/all.css";
import "./assets/css/fontawesome.min.css";
import { BrowserRouter } from 'react-router-dom';
import store from "./store";


ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
